<template>
    <div v-if="paymentMethods && paymentMethods.paypal" class="pt-2">
        <p>
            {{ $t('_checkout._payment.paypalInstruction') }}
        </p>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentPaypal',

        props: ['cart', 'customer', 'paymentMethods'],

        data() {
            return {
                description: 'PayPal',
            };
        },

        methods: {
            submit(callback) {
                callback({
                    module: 'paypal',
                    installments: 1,
                });
            },
        },
    };
</script>
